export const shorten = (value) => {
  switch (value) {
    case 'Benzine_Elektrisch':
      return 'Hybride';
    case 'Diesel_Elektrisch':
      return 'Hybride';
    default:
      return value;
  }
};

export const deEnum = (value) => {
  switch (value) {
    case 'Benzine_Elektrisch':
      return 'Hybride (benzine)';
    case 'Diesel_Elektrisch':
      return 'Hybride (diesel)';
    default:
      return value;
  }
};

export default null;
